import {
  IssueSyncIdsResponse, IssueSyncResponse, IssueSyncRowsResponse, IssueSyncScope,
} from './issue-sync-models';

// The calls the replica needs, and the failures it has to tell apart. Kept free of
// Angular on purpose: the replica depends on this file, so anything imported here is
// imported by the engine. Holding the port next to the Angular adapter made the engine
// pull in Angular and the NGXS store transitively, which defeats being drivable from a
// plain test and cannot be bundled on its own.

export interface IssueSyncTransport {
  fetchDelta(scope: IssueSyncScope, cursor: string, limit: number): Promise<IssueSyncResponse>;
  fetchIds(scope: IssueSyncScope): Promise<IssueSyncIdsResponse>;
  fetchRowsByIds(issueIds: string[]): Promise<IssueSyncRowsResponse>;
}

// The caller asked for a scope it cannot reach, and the server refused rather than
// quietly serving a wider or narrower one. The affected scope must stop syncing; other
// scopes in the store are unaffected and must not be discarded.
export class SyncScopeDeniedError extends Error {
  constructor() { super('The server refused this scope.'); }
}

// The stored cursor is not one this server issued. Recovery is to drop the cursor and
// walk the scope again from the start, never to keep retrying it.
export class SyncCursorRejectedError extends Error {
  constructor() { super('The stored cursor was rejected.'); }
}

// The server refused the ids themselves — one of them is not an Issue id. Distinct from
// a rejected cursor because the recovery is nothing like it: re-walking a scope would
// neither fix the ids nor confirm the write they belonged to.
export class SyncIdsRejectedError extends Error {
  constructor() { super('The requested ids were rejected.'); }
}
